import { css, keyframes } from 'styled-components'

export const animate = {
  spin: keyframes`
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  `,
  fadeInFromTop: keyframes`
    from {
      opacity: 0;
      transform: translate3d(0, -20%, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  `,
  fadeOutToTop: keyframes`
    from {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(0, -20%, 0);
    }
  `,
  fadeInFromRight: keyframes`
    from {
      opacity: 0;
      transform: translate3d(20%, 0, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  `,
  fadeOutToRight: keyframes`
    from {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(20%, 0, 0);
    }
  `,
  fadeInFromLeft: keyframes`
    from {
      opacity: 0;
      transform: translate3d(-20%, 0, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  `,
  fadeOutToLeft: keyframes`
    from {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(-20%, 0, 0);
    }
  `,
  fadeInFromBottom: keyframes`
    from {
      opacity: 0;
      transform: translate3d(0, 20%, 0);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  `,
  fadeOutToBottom: keyframes`
    from {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
    to {
      opacity: 0;
      transform: translate3d(, 20%, 0);
    }
  `,
  time: {
    loading: '1s',
    maxHeight: '0.5s',
    fade: '0.2s',
    opacity: '0.2s',
  },
  transition: 'all 0.5s ease',
}

export const theme = {
  maxWidth: '768px',
  mobileMaxWidth: '320px',
  color: {
    // primaryColor: '#0028D2',
    primaryColorRGB: '217, 89, 72',
    primaryColor: '#D95948',
    // secondaryColor: '#F2A840',
    secondaryColor: '#C24C4C',
    offWhite: '#FFFFFF',
    linkWater: '#FBFCFE', // almost white
    coolGrey: '#929497',
    cadetBlue: '#B3B9C6', // grey blue
    charcoalGrey: '#49484a',
    purplishGrey: '#5a595b',
    silver: '#d9d9da',
    // paleGrey: '#f7f7f8',
    paleGrey: '#dfdfdf',
    heather: '#c0bfc1',
    whiteSmoke: '#F6F5F5',
    black: '#202020',
    warning: '#e7a957',
    wildWillow: '#a9c268',
    success: '#34a820',
    error: '#c7442a',
    info: '#1B50C7',
    lost: '#FF6948',
    remark: '#FdFdFd',
    violet: '#EE82EE',
    mercury: '#E8E8E8',
    snomo: '#35405A',
    dark: '#14131B',
  },
  fonts: {
    family: {
      normal: 'sarabun',
    },
    style: {
      extraLight: '200',
      light: '300',
      regular: '400',
      medium: '500',
      semiBold: '900',
    },
    size: {
      heading: '56px',
      subHeading: '40px',
      title: '30px',
      subTitle: '22px',
      normal: '16px',
      small: '14px',
      label: '12px',
    },
  },
  animate,
}

export const screenSize = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 767,
  tablet: 991,
  laptop: 1024,
  laptopL: 1440,
  desktop: 2560,
}

export const media = Object.keys(screenSize).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media only screen and (max-width: ${screenSize[label]}px) {
      ${css(...args)}
    }
  `

  return acc
}, {})

export default theme
